module.exports = __webpack_public_path__ + "img/szdx.bdf282c7.jpg";